// Черновата на НОВО прехвърляне (`components/drafts/` — localStorage +
// сървърът, тип „transfer"): датата, двата склада, бележката и редовете.
// Същият обект е и `payload` на сървърната чернова — полетата не се
// преименуват. Етикетът в списъка е посоката („Бар → Кухня").
import dayjs, { type Dayjs } from "dayjs";
import {
  isVersionedObject,
  localDraftStore,
  type DraftPayloadBase,
  type DraftSummaryFields,
} from "../../components/drafts/draftModel";
import type { TransferLineDraft } from "./transferWorksheetShared";

export type TransferDraft = DraftPayloadBase & {
  v: 1;
  date: string; // ISO
  fromWarehouseId: number | null;
  toWarehouseId: number | null;
  note: string;
  lines: TransferLineDraft[];
};

const parseTransferDraft = (raw: unknown): TransferDraft | null => {
  if (!isVersionedObject(raw, [1])) return null;
  const draft = raw as unknown as TransferDraft;
  return Array.isArray(draft.lines) ? draft : null;
};

export const TRANSFER_DRAFT_STORE = localDraftStore("inventory_transfer_draft", parseTransferDraft);

// Празният лист не е чернова
export const hasTransferDraftContent = (draft: TransferDraft) => draft.lines.length > 0;

// Датата на черновата (невалидна → днес)
export const transferDraftDate = (draft: TransferDraft): Dayjs => {
  const date = dayjs(draft.date);
  return date.isValid() ? date : dayjs();
};

// „Бар → Кухня"; липсващ склад — „?"
export const transferDraftSummary = (sheet: {
  fromName: string | null;
  toName: string | null;
  linesCount: number;
  total: number | null;
}): DraftSummaryFields => ({
  label: sheet.fromName || sheet.toName ? `${sheet.fromName ?? "?"} → ${sheet.toName ?? "?"}` : null,
  documentType: null,
  linesCount: sheet.linesCount,
  total: sheet.total,
});

// Картата на локалната чернова (сумата иска партидите към датата — няма я)
export const localTransferDraftSummary = (
  draft: TransferDraft,
  warehouseNameOf: (warehouseId: number | null) => string | null,
): DraftSummaryFields | null =>
  hasTransferDraftContent(draft)
    ? transferDraftSummary({
        fromName: warehouseNameOf(draft.fromWarehouseId),
        toName: warehouseNameOf(draft.toWarehouseId),
        linesCount: draft.lines.length,
        total: null,
      })
    : null;
